import { WidgetUserProfileType, WidgetDisplayMode } from 'jamespot-user-api';
import { UserCurrent, Widget, WidgetEditor } from 'jamespot-front-business';

import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { useEffect } from 'react';

const WidgetUserProfile = commonComponentsRegistry.getLazyComponent('WidgetUserProfile');

type JRCWidgetUserProfileWrapperProps = {
    widget: WidgetUserProfileType;
    inplace: boolean;
    mode?: WidgetDisplayMode;
};

export const JRCWidgetUserProfileWrapper = ({ widget, mode }: JRCWidgetUserProfileWrapperProps) => {
    const dispatch = useAppDispatch();
    const { uniqid, name, content } = widget;

    const currentUser = useAppSelector(UserCurrent.selectors.get);

    useEffect(() => {
        dispatch(Widget.slice.actions.setWidgetState({ uniqid, mounted: true }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (mode === 'edit') {
            dispatch(WidgetEditor.slice.actions.flushAllEditor());
            dispatch(WidgetEditor.slice.actions.registerEditor({ uniqid, name }));
        }
    }, [dispatch, mode, name, uniqid]);

    useEffect(() => {
        if (mode === 'view' || mode === 'preview') {
            dispatch(WidgetEditor.slice.actions.flushAllEditor());
        }
    }, [mode, dispatch]);

    return (
        <WidgetUserProfile
            currentUser={currentUser}
            pictureSize={content.pictureSize}
            displayMode={content.buttonName}
            css={content.css}
        />
    );
};
